import create from 'zustand';
import { persist } from 'zustand/middleware';
import { PartnerConfig } from 'src/shared/types';

type PartnerConfigStore = {
  partnerConfig: PartnerConfig | null;
  isLoading: boolean;
  setPartnerConfig: (partnerConfig: PartnerConfig | null) => void;
  setIsLoading: (isLoading: boolean) => void;
};

export const usePartnerConfigStore = create(
  persist<PartnerConfigStore>(
    (set) => ({
      partnerConfig: null,
      isLoading: false,
      setPartnerConfig: (partnerConfig) => set({ partnerConfig }),
      setIsLoading: (isLoading) => set({ isLoading }),
    }),
    {
      name: 'usePartnerConfigStore',
    },
  ),
);
